export default class Breadcrumbs {
    constructor(endpoint) {
        this.endpoint = endpoint;
        this.key = 'cl_breadcrumb_' + endpoint;
    }
    async download() {
        try {
            const response = await fetch(
                `/api/breadcrumbs/${this.endpoint}/`,
                {
                    method: 'get',
                    headers: {
                        "X-Requested-With": "XMLHttpRequest",
                        'Accept': 'application/json',
                    },
                    credentials: "same-origin"
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            return await response.json();
        } catch (e) {
            console.error(e.error);
        }
    }

    get() {
        let raw = sessionStorage.getItem(this.key);
        if (raw) {
            return JSON.parse(raw);
        }

        const promise = this.download();
        return promise.then((data) => {
            sessionStorage.setItem(this.key, JSON.stringify(data));
        })
    }
}
